export default function generateLeadName(general) {
  return `${general.customerName}, ${general.customerPhone[0]}`;
}
